<template>
    <div
        class="m-control"
        :class="{
            'm-control--textarea': type === 'textarea',
            'm-control--textareaFullWidth': textareaFullWidth
        }"
    >
        <label :for="`mControl-${name}`" v-if="label" class="m-control__label">
            {{ label }}<span v-if="required" class="m-control__requiredStar">*</span>
        </label>
        <a-select
            v-if="type == 'search'"
            class="m-control__control"
            :placeholder="placeholder"
            @close="$emit('input', '')"
            @change="$emit('input', $event)"
            @quick-search-click="$emit('input', object ? $event : ($event && $event.name ? $event.name : $event))"
            :value="value"
            :name="name"
            :model-name="modelName"
            :id="`mControl-${name}`"
            :background-gray="backgroundGray"
            :params="params"
            :object="object"
            :multiple="multiple"
            :search-at-once="searchAtOnce"
            :fullwidth="true"
            :filter-whole-list="filterWholeList"
            :hide-single="hideSingle"
            :required="required"
        />
        <a-radio
            v-else-if="type == 'radio'"
            class="m-control__control"
            @input="$emit('input', $event)"
            :value="value"
            :name="name"
            :model-name="modelName"
            :id="`mControl-${name}`"
            :items="items"
            :required="required"
        ></a-radio>
        <a-range
            v-else-if="type == 'range'"
            class="m-control__control"
            @input="$emit('input', $event)"
            :value="value"
            :name="name"
            :model-name="modelName"
            :id="`mControl-${name}`"
            :items="items"
            :required="required"
        ></a-range>
        <a-dateRange
            v-else-if="type === 'dateRange'"
            :value="value"
            :name="name"
            @input="$emit('input', $event)"
            :required="required"
        />
        <div
            v-else-if="type == 'searchText'"
            class="a-control a-control--search m-control__control"
        >
            <a-button
                icon="Close"
                class="a-control__remove"
                @click="$emit('input', '')"
                v-show="value.length > 0"
            />
            <input
                class="a-control__input"
                :class="{ 'a-control__input--gray': backgroundGray === true }"
                type="text"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
                :value="value"
                :required="required"
            />
        </div>
        <div
            v-else-if="type == 'textarea'"
            class="a-control a-control--textarea m-control__control"
        >
            <textarea
                class="a-control__textarea"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
                :value="value"
                :required="required"
            ></textarea>
        </div>
        <div
            v-else-if="type == 'number'"
            class="
                a-control a-control--hasButton m-control__control m-control__control--fullwidth
            "
        >
            <input
                class="a-control__input"
                :class="{ 'a-control__input--gray': backgroundGray === true }"
                type="number"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
                :value="value"
                :required="required"
            />
        </div>
        <div
            v-else
            class="
                a-control m-control__control m-control__control--fullwidth
            "
        >
            <input
                class="a-control__input"
                :class="{ 'a-control__input--gray': backgroundGray === true }"
                type="text"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
                :value="value"
                :required="required"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number, Object, Array, Boolean],
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            required: true
        },
        modelName: {
            type: String,
            default: ''
        },
        items: {
            type: [Array, Number],
            default: null
        },
        backgroundGray: {
            type: Boolean,
            default: false
        },
        params: {
            type: Object,
            default: () => {}
        },
        object: {
            type: [Boolean, String],
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        searchAtOnce: {
            type: Boolean,
            default: false
        },
        filterWholeList: {
            type: Boolean,
            default: false
        },
        hideSingle: {
            type: Boolean,
            default: false
        },
        textareaFullWidth: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>
